<template>
    <div class="content-box">
        <div class="data-overview">
            <div class="data-overview__statistics">
                <!--                    <div class="statistics-item">中央花园</div>-->
                <div class="statistics-item"><span class="text-primary">共{{total}}人</span></div>
            </div>
            <div class="table-box__tool">
                <el-button type="primary" @click="queryImport">确认导入</el-button>
                <el-button plain @click="goPage('/index/member/import')">取消</el-button>
            </div>
        </div>
        <div class="table">
            <el-table
                :data="alldata"
            >
                <el-table-column
                    prop="no"
                    align="center"
                    label="序号">
                </el-table-column>
                <el-table-column
                    prop="name"
                    align="center"
                    label="姓名">
                </el-table-column>
                <el-table-column
                    prop="idcard"
                    align="center"
                    label="身份证号">
                </el-table-column>
                <el-table-column
                    prop="phone"
                    align="center"
                    label="手机号">
                </el-table-column>
                <el-table-column
                    align="center"
                    label="异常信息">
                    <template slot-scope="scope">
                        <span class="text-danger">{{scope.row.error_msg}}</span>
                    </template>
                </el-table-column>
                <el-table-column
                    label="操作"
                    align="center"
                >
                    <template slot-scope="scope">
                        <el-button v-if="scope.row.error_msg !== ''" type="text" @click="removeRow(scope.row.no)"
                                   size="medium">移除
                        </el-button>
                    </template>
                </el-table-column>
            </el-table>
        </div>
    </div>
</template>
<script>
import qs from 'qs'
import router from '@/router'

export default {
    name: 'Step2',
    inject: ['back', 'goPage', 'tel'],
    data () {
        return {
            members: [],
            total: 0,
            errMembers: [],
            signStatus: ['待认证', '待签约', '已签约']
        }
    },
    mounted () {
        this.resoveExcel(this.$route.query.id, this.$route.query.path)
    },
    computed: {
        alldata () {
            return [...this.errMembers, ...this.members]
        }
    },
    methods: {
        queryImport () {
            if (this.errMembers.length !== 0) {
                this.$message.error('请先移除异常服务人员')
            } else if (this.members.length === 0) {
                this.$message.error('导入的服务人员不能为空')
            } else {
                this.$http.post('/api/user/member/confirm', qs.stringify({
                    list: JSON.stringify(this.members),
                    id: this.$route.query.id
                }))
                    .then(res => {
                        if (res.code === 0) {
                            router.replace('/index/member/import/step3')
                        } else {
                            this.$message.error(res.message)
                        }
                    })
                    .catch(err => {
                        console.error(err)
                    })
            }
        },
        removeRow (e) {
            this.errMembers = this.errMembers.filter(({ no }) => no !== e)
        },
        resoveExcel (id, path) {
            this.$http.post('/api/user/member/import', qs.stringify({
                path,
                id
            }))
                .then(res => {
                    if (res.code === 0) {
                        this.errMembers = res.data.errorData
                        this.members = res.data.listData
                        this.total = res.data.total
                    } else {
                        this.$message.warning(res.message)
                    }
                })
                .catch(err => {
                    console.error(err)
                })
        }
    }
}
</script>

<style scoped lang="scss">
    @import "../../assets/style/sub.scss";

    .data-overview {
        height: 78px;

        .data-overview__statistics {
            font-size: 20px;
            font-weight: bold;
        }
    }
</style>
